export default __webpack_public_path__ + "static/media/subscription-success-icon.1e5eaa3b.svg";